import { Grid } from "@mantine/core"
import { IconPaperclip } from "@tabler/icons-react"
import { Tooltip } from "@tfg/ui"
import i18next from "i18next"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { Property } from "~/components/Property"
import { useFindDocumentUrlQuery } from "~/hooks/useDocumentsQuery"

import { CustomFieldDocumentDrawer } from "./CustomFieldDocumentDrawer"

type CustomFieldProductsDetailsInfoProps = {
  customFieldsDefs: LibraryResponses.ProductDetails["customFieldDefinitions"]
  allCfv: LibraryResponses.CustomFieldValue[]
}

export const CustomFieldProductsDetailsInfo = ({
  customFieldsDefs,
  allCfv,
}: CustomFieldProductsDetailsInfoProps) => {
  const { t } = useTranslation(["products", "common"])
  const [customFieldValue, setCustomFieldValue] = useState<{
    value: string
    label: string
    document: {
      id: string
      originalName: string | null
    } | null
  } | null>(null)

  const closeDrawer = () => {
    setCustomFieldValue(null)
    close()
  }
  return (
    <>
      {customFieldsDefs.map((cfd) => {
        const cfv = allCfv.find((cfv) => cfv.customFieldDefinitionId === cfd.id)
        if (!cfd) throw new Error("Custom field definition not found")
        const label =
          cfd.textContent.TextTranslation.find(
            (l) => l.translation === i18next.language.toUpperCase()
          )?.translation || cfd.textContent.originalText

        const document = cfv?.document
        const helpText = document
          ? t("traceability.itemCard.documentName")
          : undefined

        return (
          <div key={`${cfd.id}-${cfv?.id}`}>
            <Grid>
              <Grid.Col span={11}>
                <Property label={label} value={cfv?.value} size="sm" bold />
              </Grid.Col>
              <Grid.Col
                span={1}
                style={{ display: "flex", alignItems: "center" }}
              >
                {document && (
                  <Tooltip label={helpText}>
                    <IconPaperclip
                      size={16}
                      stroke={1.5}
                      cursor="pointer"
                      style={{ alignSelf: "flex-start" }}
                      onClick={() => {
                        setCustomFieldValue({
                          value: cfv?.value || "",
                          label,
                          document: cfv?.document,
                        })
                      }}
                    />
                  </Tooltip>
                )}
              </Grid.Col>
            </Grid>
          </div>
        )
      })}
      {customFieldValue && (
        <CustomFieldDocumentDrawer
          opened={!!customFieldValue}
          onClose={closeDrawer}
          document={customFieldValue?.document}
          label={customFieldValue?.label}
          cfv={{ value: customFieldValue?.value }}
        />
      )}
    </>
  )
}

export const DocumentIFrame = ({
  documentId,
  height = "100%",
  width = "100%",
}: {
  documentId: string
  height?: string
  width?: string
}) => {
  const documentUrlQuery = useFindDocumentUrlQuery(documentId)

  return (
    <DataFetchWrapper query={documentUrlQuery}>
      {(data) => {
        return <iframe src={data.data} height={height} width={width} />
      }}
    </DataFetchWrapper>
  )
}
